














import { Component, Prop, Vue } from "vue-property-decorator";
import { CalendarData } from "../types";
import moment from "moment";

@Component
export default class MeetingArea extends Vue {
    @Prop() nextMeeting!: CalendarData;
    @Prop() translations!: any;

    mom = moment;
}
